import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {map, takeUntil} from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';

import { navigation } from 'app/navigation/navigation';
import { UserModel } from '../../../models/user.model';
import { AuthService } from '../../../services/auth.service';
import { TenantSelectorService } from 'app/services/tenant-selector.service';
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';
import { DialogService } from 'app/dialogs/dialog.service';
import {
    LDD_GLOBAL_MODULES,
    LDD_MODULES,
    PalettePickerComponent,
    ThemeBuilderData
} from '../../../../theme-builder/palette-picker/palette-picker.component';
import { Item } from 'app/models/item.inferface';
import { Utils } from 'app/infrastructure/utils';
import { Tenant } from 'app/models/tenant.model';
import { NotificationService } from 'app/services/notification.service';
import {ThemingService} from '../../../theming.service';
import { ToastService } from 'app/services/toast.service';
import { ReportService } from 'app/services/report.service';
import { PanelsName } from 'app/enums/panels.enum';
import { Router } from '@angular/router';
import { ReportType } from 'app/enums/report-panel.enum';
import { PermissionType } from 'app/enums/permission.enum';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';
import { MatDialog } from '@angular/material/dialog';

// import * as _ from 'lodash';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class ToolbarComponent implements OnInit, OnDestroy {
    horizontalNavbar: boolean;
    rightNavbar: boolean;
    hiddenNavbar: boolean;

    // tslint:disable-next-line: no-any
    navigation: any;
    // tslint:disable-next-line: no-any
    userStatusOptions: any[];

    currentUser$: Observable<UserModel>;

    selected: Tenant; // = JSON.parse(MVLocalStorageService.getItem('current_user'))?.selectedTenant;
    
    tenants$: Observable<Tenant[]>;

    newAlerts: number;
    newReports: number;

    panels = PanelsName;

    version: string = require('../../../../../../source/package.json').version;
    // Private
    private unsubscribeAll: Subject<void>;
    canAdminGlobalContent:boolean;
    reportsButton: boolean = false;

    constructor(
        private _fuseConfigService: FuseConfigService,
        private _fuseSidebarService: FuseSidebarService,
        private translate: TranslateService,
        private themeService: ThemingService,
        private _authService: AuthService,
        private dialogService: DialogService,
        public _tenantSelectorService: TenantSelectorService,
        private notificationService: NotificationService,
        private reportService: ReportService,
        public matDialog: MatDialog,
        public _toast : ToastService,
        private languageSelectorComponent: LanguageSelectorComponent
    ) {
        // Set the defaults
        this.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.navigation = navigation;

        // Set the private defaults
        this.unsubscribeAll = new Subject();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        // Subscribe to the config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this.unsubscribeAll))
            .subscribe((settings) => {
                this.horizontalNavbar = settings.layout.navbar.position === 'top';
                this.rightNavbar = settings.layout.navbar.position === 'right';
                this.hiddenNavbar = settings.layout.navbar.hidden === true;
            });

        // Login User Data
        this.currentUser$ = this._authService.currentUser$ ?? null;
        this.tenants$ = this._tenantSelectorService.tenants;
        this._tenantSelectorService.selectedTenant
            .subscribe(tenant => this.selected = tenant);
        // this.currentUser$.subscribe(
        //     user => {
        //         if(user){
        //             if(user.managedTenants){
        //                 this.tenantArray = user.managedTenants;
        //             }
        //         }
        //     }
        // )
        this.currentUser$.subscribe(user => this.canAdminGlobalContent = user?.canAdminGlobalContent);
        // MVLocalStorageService.setItem('current_user'

        // Notifications
        this.notificationService.notifications$.pipe(map(notifications => notifications?.filter(notif => !notif.isDone).length ?? 0))
          .subscribe(count => this.newAlerts = count);

        // Reports || TODO: update when DTO avalaible
        this.reportService.reports$.pipe(map(reports => reports?.filter(report => !report.isDone).length ?? 0))
          .subscribe(count => this.newReports = count);
        
        this.currentUser$.subscribe(user => {
            if(user){
                user.initials = user.fullUserName.split(' ')[0].split('')[0] + user.fullUserName.split(' ')[1].split('')[0];
            }
            user?.permissions.map(x => {
                // if(x.id == (PermissionType.FlatReportAlert || PermissionType.FlatReportCase || PermissionType.FlatReportComplaint || PermissionType.RequestFlatFilesReport ||
                //     PermissionType.FlatAlertReportDetail || PermissionType.FlatCaseReportDetail || PermissionType.FlatComplaintReportDetail || PermissionType.GenerateAlertReport ||
                //     PermissionType.GenerateCaseReport || PermissionType.GenerateComplaintReport)){
                //     this.reportsButton = true;
                // }
                switch(x.id){
                    case PermissionType.FlatAlertReportDetail: this.reportsButton = true;
                    case PermissionType.FlatReportAlert: this.reportsButton = true;
                    case PermissionType.FlatReportCase: this.reportsButton = true;
                    case PermissionType.FlatReportComplaint: this.reportsButton = true;
                    case PermissionType.FlatCaseReportDetail: this.reportsButton = true;
                    case PermissionType.FlatComplaintReportDetail: this.reportsButton = true;
                    case PermissionType.GenerateAlertReport: this.reportsButton = true;
                    case PermissionType.GenerateCaseReport: this.reportsButton = true;
                    case PermissionType.GenerateComplaintReport: this.reportsButton = true;
                    case PermissionType.RequestFlatFilesReport: this.reportsButton = true;
                }
            });
        }); 
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this.unsubscribeAll.next(void 0);
        this.unsubscribeAll.complete();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Toggle sidebar open
     *
     * @param key key
     */
    toggleSidebarOpen(key: string): void {
        if (Utils.isNullOrWhiteSpace(key)) {
            return;
        } else {
            this._fuseSidebarService.getSidebar(key).toggleOpen();
        }
    }

    /**
     * Search
     *
     * @param value comment
     */
    search(value): void {
        // Do your search here...
    }

    logout(): void {
        const msg = this.translate.instant(`DIALOGS.LOGOUT.TITLE`);

        this.dialogService.openConfirmDialog(msg, '')
            .afterClosed()
            .subscribe((confirmed: boolean) => {
                if (confirmed) {
                    this._authService.logout();
                }
            });
    }

    openThemeSettings() {

    }

    selectTenant(tenant: Tenant){
        this._tenantSelectorService.selectTenant(tenant);
        this.languageSelectorComponent.getFullLabels(MVLocalStorageService.getItem('selected_lang') ? JSON.parse(MVLocalStorageService.getItem('selected_lang')).id : 1)
    }

    openTenantThemeSettings() {
        this.matDialog.open<PalettePickerComponent, ThemeBuilderData>(PalettePickerComponent, {
            data: {
                initialData: this.themeService.currentTheme,
                onThemeChange: (x) => this.themeService.previewTheme(x),
                modules: LDD_MODULES,
                onCancel: () => {},
                onPersist: () => this.themeService.persistPreviewedTheme(),
            },
            minWidth: '80vw',
            maxWidth: '80vw'
        });
    }

    openGlobalThemeSettings() {
        this.matDialog.open<PalettePickerComponent, ThemeBuilderData>(PalettePickerComponent, {
            data: {
                initialData: this.themeService.getLDDTheme(),
                onThemeChange: (x) => {},
                modules: LDD_GLOBAL_MODULES,
                onCancel: () => {},
                onPersist: (x) => {
                    this.themeService.persistLDDTheme(x)
                },
            },
            minWidth: '80vw',
            maxWidth: '80vw'
        });
    }
}
